/**
 * @ngdoc service
 * @param $window
 * @param $document
 * @param environment
 * @param $location
 * @param $httpParamSerializer
 * @param $q
 * @returns {{twitter: ({post}|{post: post}), facebook: ({post}|{post: post})}}
 * @constructor
 */
export default function ShareService($window, $document, environment, $location, $httpParamSerializer, $q) {
  'ngInject';
  /**
   * @description Sharing to twitter
   * @returns {{post: post}}
   */
  function twitter() {
    /**
     * @description Sends a status update to twitter including photos
     * @param message
     * @return {*}
     */
    function post(message) {
      let request = $q.defer();
      let data;
      //Check if photo exists in the message
      let {photo, caption} = message;
      //If so then change the payload to include a media array
      if (photo && caption) {
        data = {
          media: [photo],
          text: caption
        };
      }
      //Other wise we just need the text
      else {
        data = {
          text: message.text
        };
      }
      //Create a window pointing to our OAuth app start point.
      let url = `${environment.site.parent}/users/twitter_post?${$httpParamSerializer({
        post_data: data,
        protocol: `${$location.protocol()}:`
      })}`;
      window.open(url, '', 'left=20,top=20,width=520,height=300,toolbar=0,resizable=0');
      //The window message handler. We assume completion and error statuses are coming in the form of window post messages.
      function msgHandle(event) {
        //Resolve the promise
        if (event.data.errors) {
          let messages = event.data.errors.reduce(function (prev, error) {
            return `${prev} ${error.message}`;
          });
          request.reject(messages);
        }
        request.resolve();
        //Only do this once.
        window.removeEventListener('message', msgHandle);
      }

      //Listen to the window we just created.
      //TODO - HIGH - Ensure the message was from the previously created window.
      window.addEventListener('message', msgHandle);
      //Return the promise
      return request.promise;
    }

    //Actions to expose
    return {
      post
    };
  }

  /**
   * @description Sharing to facebook
   * @returns {{post: post}}
   */
  function facebook() {

    /**
     * @description Sends a photoObj upload to facebook and posts it with the caption.
     * @param photoObj
     * @param caption
     * @return {*}
     */
    function photo(photoObj, caption) {
      //Create payload
      let data = {
        url: photoObj,
        caption
      };
      let request = $q.defer();
      //Hit Api
      FB.login(function () {
        //After Auth then upload photoObj
        FB.api('/me/photos', 'post', data, function (response) {
          if (response && !response.error) {
            //Resolve the promise
            request.resolve();
          }
          else {
            //TODO - MED - Error
            request.reject();
          }
        });
      }, {scope: 'publish_actions'});
      //Return the promise
      return request.promise;
    }

    /**
     * @description Sends a status update to facebook, if the message contains a photo, then send the photo instead.
     * @param message
     * @returns {*}
     */
    function post(message) {
      let data;
      //Check if photo exists
      let {photo: photoUrl, caption} = message;
      //If photo, then run photo api method and exit.
      if (photoUrl && caption) {
        return photo(photoUrl, caption);
      }
      let request = $q.defer();
      //Create payload
      data = {
        message: message.text
      };
      //Hit api
      FB.login(function () {
        //After Auth then post
        FB.api('/me/feed', 'post', data, function (response) {
          if (response && !response.error) {
            //Resolve the promise
            request.resolve();
          }
          else {
            //TODO - MED - Error
            request.reject();
          }
        });
      }, {scope: 'publish_actions'});
      //Return the promise
      return request.promise;
    }

    //Actions to expose to callers.
    return {
      post
    };
  }

  //Add more strategies here
  //TODO - G+
  const strategies = {
    //Expose a simple api to consumers.
    twitter: twitter(),
    facebook: facebook()
  };
  return strategies;
}



/** WEBPACK FOOTER **
 ** ./src/app/components/share/share.service.js
 **/